<generic-search-results
        [showHeader]="false"
        [showCounter]="false"
        [title]="''"
        [records]="accountsUnlocked"
        [displayedColumns]="accountColumns"
        [selectableRecords]="false"
        [allowLocalFilter]="false"
    ></generic-search-results>